import { Test, Variation } from './types';

const showTracking = /hound=1/.test(document.cookie);

function logTracking(event: { [key: string]: string | undefined }) {
  if (showTracking) {
    let output = '\ud83d\udc63 ';
    const styling = [];
    for (const key in event) {
      // Still want to see value of 0 get tracked
      const value = event[key];
      if (![undefined, null, ''].includes(value)) {
        output += `%c${key[0].toUpperCase() + key.substr(1)}:%c ${value} `;
        styling.push(
          'color: #00f; font-weight: bold; background-color: #ddd; border-radius: 2px; padding: 0 2px;',
        );
        styling.push('color: #444');
      }
    }
    console.log(output, ...styling);
  }
}

function trackExperiment(
  experimentId: string,
  variationId: string | undefined,
  assignmentId: string,
) {
  if (typeof window.sp === 'function') {
    window.sp('trackUnstructEvent:cf', {
      schema: 'iglu:com.trello/experiment-event/jsonschema/1-0-0',
      data: {
        experiment_id: experimentId,
        variation_id: variationId,
        assignment_id: assignmentId,
      },
    });
  }
  logTracking({ experimentId, variationId, assignmentId });
}

export default class CollapsedTest {
  test: Test;
  selectedVariation: Variation | undefined;
  identifier: string;

  constructor(
    test: Test,
    selectedVariation: Variation | undefined,
    identifier: string,
  ) {
    this.test = test;
    this.selectedVariation = selectedVariation;
    this.identifier = identifier;
  }
  track() {
    return trackExperiment(
      this.test.name + this.test.experimentVersion,
      this.selectedVariation ? this.selectedVariation.name : undefined,
      this.identifier,
    );
  }
  get inExperiment() {
    return !!this.selectedVariation;
  }
  get(name: string) {
    if (name === 'variation') {
      if (this.selectedVariation && this.selectedVariation.name) {
        return this.selectedVariation.name;
      } else {
        return 'control';
      }
    } else if (
      this.selectedVariation &&
      this.selectedVariation.values &&
      this.selectedVariation.values.hasOwnProperty(name)
    ) {
      return this.selectedVariation.values[name];
    } else if (this.test.defaults && this.test.defaults.hasOwnProperty(name)) {
      return this.test.defaults[name];
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./app/common/lib/experiments/collapsed-test.ts